import { z } from 'zod';

export enum OrganizationStatus {
  ARCHIVED = 'ARCHIVED',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
}

export const OrganizationTypeEnum = z.enum(['ORGANIZATION', 'TRAINER']);

export type OrganizationType = z.infer<typeof OrganizationTypeEnum>;

// F8 — machine-readable BE error codes for the owner-handover primitives
// (promote/invite-owner/close-org/leave). FE branches on `error.code`, never
// on the translated message (same convention as PaymentApiErrorCode).
export enum OrganizationApiErrorCode {
  // The caller is the last ACTIVE owner of the organization — leaving would
  // orphan it. FE shows the 3-option popup (promote / invite / close).
  LAST_OWNER = 'LAST_OWNER',
  // P2/Q12: a platform actor may archive only after the organization's own
  // payer has ended platform billing. The back office must never settle or
  // schedule a charge on the customer's instrument as a side effect.
  LIVE_BILLING_SUBSCRIPTION = 'LIVE_BILLING_SUBSCRIPTION',
  // Another non-archived organization in the same tenant already holds this
  // (trimmed, case-insensitive) name. FE sets an inline error on the name
  // field rather than the global error toast.
  NAME_TAKEN = 'NAME_TAKEN',
}
